/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statistics_TitleInputs */

const he_statistics_title = /** @type {(inputs: Statistics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`סטטיסטיקות`)
};

const en_statistics_title = /** @type {(inputs: Statistics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistics`)
};

/**
* | output |
* | --- |
* | "Statistics" |
*
* @param {Statistics_TitleInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const statistics_title = /** @type {((inputs?: Statistics_TitleInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statistics_TitleInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_statistics_title(inputs)
	return en_statistics_title(inputs)
});